import React, { Component } from 'react'
import './ScoreKeeper.css';

export default class ScoreKeeper extends Component{
    constructor () {
        super ();

        this.state = {
            lastScore: 0
        }
    }
    animateScore () {
        this.setState ({ lastScore: this.props.score });
    }

    render () {
        let className = 'score-keeper';

        if (this.props.type === 'total') { className += ' total' }

        return (
            <div className={className}>
                <div className="label">
                    { this.props.label }
                </div>
                <div className="score">
                    { this.props.score }
                </div>
            </div>
        )
    }
}
